import { FunctionComponent, h } from 'preact'
import { Link } from 'preact-router'
import { useState, useEffect } from 'preact/hooks'
import { PAGES_EN } from '../../core/Pages'
import useOuterClick from '../../hooks/useOuterClick'

import * as classes from './BurgerMenu.module.css'

const MENU = [
    {
        text: 'About',
        href: PAGES_EN.ABOUT,
    },
    { 
        text: 'Chapters', 
        href: PAGES_EN.CHAPTERS 
    },
    {
        text: 'Artists',
        href: PAGES_EN.ARTISTS,
    },
]

const BurgerMenu: FunctionComponent = () => {
    const [isOpen, setIsOpen] = useState(false)
    const ref = useOuterClick<HTMLDivElement>(() => setIsOpen(false))

    useEffect(() => {
        const body = document.body.classList
        const root = document.documentElement.classList

        toggle(body)
        toggle(root)

        return () => {
            document.body.classList.remove('u-overflow-y-hidden')
            document.documentElement.classList.remove('u-overflow-y-hidden')
        }
    }, [isOpen])

    const toggle = (element: DOMTokenList) => {
        isOpen
            ? element.add('u-overflow-y-hidden')
            : element.remove('u-overflow-y-hidden')
    }

    const close = () => setIsOpen(false)

    return (
        <nav className={`${isOpen ? classes.active : ''}`} ref={ref}>
            <div
                className={`${classes.burger}`}
                onClick={() => setIsOpen(!isOpen)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" data-name="Layer 1" viewBox="0 0 52 52"><path d="M50 12.5H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4ZM50 28H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4ZM50 43.5H2a2 2 0 0 1 0-4h48a2 2 0 0 1 0 4Z" /></svg>
            </div>

            <div
                className={classes.drawer}
                style={{ display: isOpen ? 'flex' : 'none' }}
            >
                <div
                    className={classes.closeIcon}
                    onClick={() => setIsOpen(false)}
                >
                    ✕
                </div>

                <ul className={classes.drawerMenu}>
                    {MENU.map((item) => (
                        <li className={classes.drawerMenuItem}>
                            <Link href={item.href} onClick={close}>
                                {item.text}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>

            {isOpen && (
                <div className={classes.backgroundBlur} onClick={close} />
            )}
        </nav>
    )
}

export default BurgerMenu
